/* Privatefun — de tweede productfoto pas ophalen als er echt gehoverd kan worden.

   snippets/pf-bestseller-media.liquid zet de bron in data-pf-hover in plaats van in src.
   Dit script vult src alsnog, maar alleen op een apparaat met een echte aanwijzer en pas
   bij de eerste keer dat die aanwijzer de kaart raakt.

   Waarom pointerenter en niet mouseenter: pointerenter vuurt ook bij een pen, en op een
   telefoon vuurt hij bij een tik — vandaar de controle op de mediaquery erbij. Zonder die
   controle zou een tik op een telefoon de foto alsnog ophalen en was de winst weg.

   Werkt voor elke kaart met een [data-pf-hover] erin, dus ook als de bestsellers ooit op
   een tweede plek gebruikt worden. */
(function () {
  'use strict';

  var KAN_HOVER = '(hover: hover) and (pointer: fine)';

  function laad(kaart) {
    var foto = kaart.querySelector('img[data-pf-hover]');
    if (!foto) return;
    foto.src = foto.getAttribute('data-pf-hover');
    foto.removeAttribute('data-pf-hover');
  }

  function koppel(kaart) {
    if (kaart.dataset.pfHoverKlaar) return;
    kaart.dataset.pfHoverKlaar = '1';
    kaart.addEventListener(
      'pointerenter',
      function () {
        if (!window.matchMedia(KAN_HOVER).matches) return;
        laad(kaart);
      },
      { once: true }
    );
  }

  function zoek(binnen) {
    var wortel = binnen && binnen.querySelectorAll ? binnen : document;
    var fotos = wortel.querySelectorAll('img[data-pf-hover]');
    for (var i = 0; i < fotos.length; i++) {
      var kaart = fotos[i].closest('[class*="__card"]') || fotos[i].parentElement;
      if (kaart) koppel(kaart);
    }
  }

  function start() {
    zoek(document);
    if (!window.MutationObserver) return;
    new MutationObserver(function (lijst) {
      for (var i = 0; i < lijst.length; i++) {
        var nieuw = lijst[i].addedNodes;
        for (var j = 0; j < nieuw.length; j++) {
          if (nieuw[j].nodeType === 1) zoek(nieuw[j]);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
